// 移动端路由配置
const mobileRoutes = [{
	path: '/m',
	name: 'MobileApp',
	component: () => import('@/mobile/MobileApp.vue'),
	children: [{
			path: '',
			redirect: 'home'
		},
		{
			path: 'home',
			name: 'MHome',
			component: () => import('@/mobile/views/MHome.vue'),
			meta: { title: '首页', description: '建数工厂 - 免费查询全国招标信息、建筑企业资质，提供监理费、设计费、造价咨询费等20+在线工程计算器，助力建筑从业者高效决策。' }
		},
		{
			path: 'calc',
			name: 'MCalcList',
			component: () => import('@/mobile/views/MCalcList.vue'),
			meta: { title: '工程费用计算器', description: '建数工厂免费工程费用在线计算，涵盖监理费、设计费、招标代理费、造价咨询费、环评费等20+计算器，结果精准、操作简便。' }
		},
		{
			path: 'calc/CalcOne',
			name: 'MCalcOne',
			component: () => import('@/mobile/views/calc/MCalcOne.vue'),
			meta: { title: '通用监理费计算器', description: '建设工程监理费在线计算，依据发改价格[2007]670号收费标准，输入工程概算投资额，自动输出监理费基准价及折后金额。' }
		},
		{
			path: 'calc/CalcOneSichuan',
			name: 'MCalcOneSichuan',
			component: () => import('@/mobile/views/calc/MCalcOneSichuan.vue'),
			meta: { title: '四川监理费计算器', description: '四川省建设工程监理费在线计算，依据四川省地方收费标准，支持不同专业类别与阶段的系数调整。' }
		},
		{
			path: 'calc/CalcOneGd',
			name: 'MCalcOneGd',
			component: () => import('@/mobile/views/calc/MCalcOneGd.vue'),
			meta: { title: '广东监理费计算器', description: '广东省建设工程监理费在线计算，依据粤价[2011]84号收费标准，支持房建、市政等多类工程及折率调整。' }
		},
		{
			path: 'calc/CalcOneSd',
			name: 'MCalcOneSd',
			component: () => import('@/mobile/views/calc/MCalcOneSd.vue'),
			meta: { title: '山东监理费计算器', description: '山东省建设工程监理费在线计算，依据山东省地方收费标准，快速计算房建、市政、交通等工程监理费用。' }
		},
		{
			path: 'calc/CalcOneHb',
			name: 'MCalcOneHb',
			component: () => import('@/mobile/views/calc/MCalcOneHb.vue'),
			meta: { title: '河北监理费计算器', description: '河北省建设工程监理费在线计算，依据河北省地方收费标准，支持专业系数及折率调整，结果即时呈现。' }
		},
		{
			path: 'calc/CalcTwo',
			name: 'MCalcTwo',
			component: () => import('@/mobile/views/calc/MCalcTwo.vue'),
			meta: { title: '招标代理费计算器', description: '招标代理服务费在线计算，依据国家发改委收费标准，输入中标金额快速得出代理费，支持货物类、服务类、工程类。' }
		},
		{
			path: 'calc/CalcTwoSd',
			name: 'MCalcTwoSd',
			component: () => import('@/mobile/views/calc/MCalcTwoSd.vue'),
			meta: { title: '山东招标代理费计算器', description: '山东省招标代理服务费在线计算，依据山东省地方收费标准，快速计算工程项目招标代理费用。' }
		},
		{
			path: 'calc/CalcTwoHb',
			name: 'MCalcTwoHb',
			component: () => import('@/mobile/views/calc/MCalcTwoHb.vue'),
			meta: { title: '河北招标代理费计算器', description: '河北省招标代理服务费在线计算，依据河北省地方收费标准，快速计算工程项目招标代理费用。' }
		},
		{
			path: 'calc/CalcThree',
			name: 'MCalcThree',
			component: () => import('@/mobile/views/calc/MCalcThree.vue'),
			meta: { title: '造价咨询费计算器', description: '工程造价咨询服务费在线计算，依据国家收费标准，按工程概算投资额自动计算，支持全过程、竣工结算等咨询类型。' }
		},
		{
			path: 'calc/CalcThreeSichuan',
			name: 'MCalcThreeSichuan',
			component: () => import('@/mobile/views/calc/MCalcThreeSichuan.vue'),
			meta: { title: '四川造价咨询费计算器', description: '四川省工程造价咨询服务费在线计算，依据四川省地方收费标准，快速计算各阶段造价咨询费。' }
		},
		{
			path: 'calc/CalcFour',
			name: 'MCalcFour',
			component: () => import('@/mobile/views/calc/MCalcFour.vue'),
			meta: { title: '前期咨询费计算器', description: '建设项目前期咨询费在线计算，依据国家计委收费标准，输入估算投资额自动计算可行性研究、评估等咨询费用。' }
		},
		{
			path: 'calc/CalcFourSichuan',
			name: 'MCalcFourSichuan',
			component: () => import('@/mobile/views/calc/MCalcFourSichuan.vue'),
			meta: { title: '四川前期咨询费计算器', description: '四川省建设项目前期咨询费在线计算，依据四川省地方标准，快速计算项目建议书、可研等阶段咨询费。' }
		},
		{
			path: 'calc/CalcFive',
			name: 'MCalcFive',
			component: () => import('@/mobile/views/calc/MCalcFive.vue'),
			meta: { title: '建设单位管理费计算器', description: '建设单位管理费在线计算，依据财政部相关规定，按建设项目总概算额计算建设单位日常管理费用。' }
		},
		{
			path: 'calc/CalcSix',
			name: 'MCalcSix',
			component: () => import('@/mobile/views/calc/MCalcSix.vue'),
			meta: { title: '工程勘察费计算器', description: '工程勘察费在线计算，依据国家工程勘察收费标准，支持岩土工程勘察、测量等类型，实物工作量与技术工作费分项展示。' }
		},
		{
			path: 'calc/CalcSeven',
			name: 'MCalcSeven',
			component: () => import('@/mobile/views/calc/MCalcSeven.vue'),
			meta: { title: '工程保险费计算器', description: '工程保险费在线计算，支持建筑工程一切险和安装工程一切险，依据保险费率自动计算保险费金额。' }
		},
		{
			path: 'calc/CalcEight',
			name: 'MCalcEight',
			component: () => import('@/mobile/views/calc/MCalcEight.vue'),
			meta: { title: '环境影响评价费计算器', description: '环境影响评价费在线计算，依据计价格[2002]125号收费标准，按项目类型和投资规模自动计算环评报告书、报告表费用。' }
		},
		{
			path: 'calc/CalcZero',
			name: 'MCalcZero',
			component: () => import('@/mobile/views/calc/MCalcZero.vue'),
			meta: { title: '通用设计费计算器', description: '工程设计费在线计算，依据国家工程勘察设计收费标准，输入工程费用金额，自动计算设计基准价，支持调整系数与折扣设置。' }
		},
		{
			path: 'calc/CalcZeroGdOne',
			name: 'MCalcZeroGdOne',
			component: () => import('@/mobile/views/calc/MCalcZeroGdOne.vue'),
			meta: { title: '广东建筑装饰设计费计算器', description: '广东省建筑装饰工程设计费在线计算，支持按工程费或建筑面积两种计费方式，可调整地区、专业、复杂度等系数。' }
		},
		{
			path: 'calc/CalcZeroGdTwo',
			name: 'MCalcZeroGdTwo',
			component: () => import('@/mobile/views/calc/MCalcZeroGdTwo.vue'),
			meta: { title: '广东市政工程设计费计算器', description: '广东省市政工程设计费在线计算，覆盖市政道路、城市轨道、隧道、管线综合、交通工程五大类型，自动匹配收费标准。' }
		},
		{
			path: 'calc/CalcZeroGdThree',
			name: 'MCalcZeroGdThree',
			component: () => import('@/mobile/views/calc/MCalcZeroGdThree.vue'),
			meta: { title: '广东岩土工程设计费计算器', description: '广东省岩土工程设计咨询费在线计算，依据粤价[2002]216号标准，支持简单、中等、复杂三个复杂度等级计算。' }
		},
		{
			path: 'calc/CalcZeroHb',
			name: 'MCalcZeroHb',
			component: () => import('@/mobile/views/calc/MCalcZeroHb.vue'),
			meta: { title: '河北工程设计费计算器', description: '河北省工程设计费在线计算，依据河北省地方收费标准，支持专业调整系数与附加调整费率，快速得出设计费结果。' }
		},
		{
			path: 'calc/CalcShuitu',
			name: 'MCalcShuitu',
			component: () => import('@/mobile/views/calc/MCalcShuitu.vue'),
			meta: { title: '水土保持费计算器', description: '水土保持费在线计算，依据保监[2005]22号标准，支持方案编制费、水保监测费、设施验收费三类费用计算。' }
		},
		{
			path: 'calc/CalcJiaotong',
			name: 'MCalcJiaotong',
			component: () => import('@/mobile/views/calc/MCalcJiaotong.vue'),
			meta: { title: '交通影响评价费计算器', description: '交通影响评价费在线计算，依据行业收费标准，按建设项目总建筑面积或用地面积自动计算评价服务费用。' }
		},
		{
			path: 'calc/CalcJsqlx',
			name: 'MCalcJsqlx',
			component: () => import('@/mobile/views/calc/MCalcJsqlx.vue'),
			meta: { title: '建设期利息计算器', description: '建设期贷款利息在线计算，输入贷款金额、利率及建设年限，自动按年分期计算建设期利息，结果逐年列示。' }
		},
		{
			path: 'calc/CalcYbf',
			name: 'MCalcYbf',
			component: () => import('@/mobile/views/calc/MCalcYbf.vue'),
			meta: { title: '预备费计算器', description: '工程预备费在线计算，包含基本预备费与涨价预备费两部分，依据项目投资额和预备费率自动计算，符合概算编制规范。' }
		},
		{
			path: 'calc/CalcLdaqwsps',
			name: 'MCalcLdaqwsps',
			component: () => import('@/mobile/views/calc/MCalcLdaqwsps.vue'),
			meta: { title: '劳动安全卫生评审费计算器', description: '劳动安全卫生预评价及验收评审费在线计算，依据行业收费标准，按项目投资规模自动计算评审费用。' }
		},
		{
			path: 'calc/CalcDzzh',
			name: 'MCalcDzzh',
			component: () => import('@/mobile/views/calc/MCalcDzzh.vue'),
			meta: { title: '地质灾害评估费计算器', description: '地质灾害危险性评估费在线计算，依据行业收费标准，支持一级、二级、三级评估等级的费用估算。' }
		},
		{
			path: 'calc/CalcShwd',
			name: 'MCalcShwd',
			component: () => import('@/mobile/views/calc/MCalcShwd.vue'),
			meta: { title: '社会稳定风险评估费计算器', description: '社会稳定风险评估费在线计算，依据行业收费标准，按项目投资规模和评估级别计算评估服务费用。' }
		},
		{
			path: 'calc/CalcZcpg',
			name: 'MCalcZcpg',
			component: () => import('@/mobile/views/calc/MCalcZcpg.vue'),
			meta: { title: '资产评估费计算器', description: '资产评估服务费在线计算，依据中国资产评估协会收费参考标准，按评估资产价值额累进计算评估费。' }
		},
		{
			path: 'query',
			name: 'MQuery',
			component: () => import('@/mobile/views/MQuery.vue'),
			meta: { title: '企业资质查询', description: '免费查询全国建筑企业资质，支持按企业名称、资质类别、注册地区多维度筛选，覆盖特级、一级、二级等各类资质信息。' }
		},
		{
			path: 'query/detail',
			name: 'MQueryDetail',
			component: () => import('@/mobile/views/MQueryDetail.vue'),
			meta: { title: '企业详情', description: '查看建筑企业详细资质信息，包括资质等级、证书编号、有效期、法人代表、注册资金及联系方式。' }
		},
		{
			path: 'bidding',
			name: 'MBidding',
			component: () => import('@/mobile/views/MBidding.vue'),
			meta: { title: '招标信息', description: '实时更新的全国工程招标公告，可按项目名称、发布时间、项目类型、公告类型、地区精准筛选，快速找到目标招标项目。' }
		},
		{
			path: 'bidding/detail',
			name: 'MBiddingDetail',
			component: () => import('@/mobile/views/MBiddingDetail.vue'),
			meta: { title: '招标详情', dynamicTitle: true, description: '查看完整招标公告内容，包括项目概况、招标单位、投标资质要求、报名时间及联系方式等详细信息。' }
		},
		{
			path: 'mine',
			name: 'MMine',
			component: () => import('@/mobile/views/MMine.vue'),
			meta: { title: '我的', description: '建数工厂个人中心，管理账户信息、查看历史计算记录及收藏的招标信息。' }
		}
	]
}]

export default mobileRoutes
